
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[post_id_name]",
      function () {
        return require("private-next-pages/blog/[post_id_name].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[post_id_name]"])
      });
    }
  